export function parseDateDMY(dateStr: string): Date | null {
	const match = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})/);
	if (!match) return null;
	const [, day, month, year] = match;
	return new Date(+year, +month - 1, +day);
}

export function periodToDateRange(
	periodo: string,
	customFrom: string,
	customTo: string
): { from: Date | null; to: Date | null } {
	if (periodo === '15' || periodo === '30') {
		const days = Number.parseInt(periodo, 10);
		const to = new Date();
		to.setHours(23, 59, 59, 999);
		const from = new Date();
		from.setDate(from.getDate() - (days - 1));
		from.setHours(0, 0, 0, 0);
		return { from, to };
	}
	if (periodo === 'custom') {
		let from: Date | null = null;
		let to: Date | null = null;
		if (customFrom) { from = new Date(customFrom); from.setHours(0, 0, 0, 0); }
		if (customTo) { to = new Date(customTo); to.setHours(23, 59, 59, 999); }
		return { from, to };
	}
	return { from: null, to: null };
}

export function buildUnionDateRange(
	periodoFilters: string[],
	customFrom: string,
	customTo: string
): { from: Date | null; to: Date | null } {
	let unionFrom: Date | null = null;
	let unionTo: Date | null = null;
	for (const periodo of periodoFilters) {
		const { from, to } = periodToDateRange(periodo, customFrom, customTo);
		if (from && (!unionFrom || from < unionFrom)) unionFrom = from;
		if (to && (!unionTo || to > unionTo)) unionTo = to;
	}
	return { from: unionFrom, to: unionTo };
}

export function isInDateRange(dateStr: string, from: Date | null, to: Date | null): boolean {
	const d = parseDateDMY(dateStr);
	if (!d) return true;
	if (from && d < from) return false;
	if (to && d > to) return false;
	return true;
}
